import { Configuration } from './services/configuration';
import { environment } from '../environments/environment';

export const walletConfig: Configuration = {
  networks: environment.networks
};
